import { Action, createReducer, on } from '@ngrx/store';

import { PremiumEstimate } from '@amfam/policy/models';
import { ApiStatus, PaymentScheduleItem } from '@amfam/shared/models';

import * as quickQuoteDataActions from './quick-quote-data.actions';

export interface QuickQuoteDataState {
  loaded: boolean;
  loading: boolean;
  premium: PremiumEstimate;
  paymentSchedule?: PaymentScheduleItem[];
  error: boolean;
  status: ApiStatus;
  ansError: boolean;
  ansStatus: ApiStatus;
  exceptionAnsError: boolean;
  exceptionAnsStatus: ApiStatus;
}

export const initialState: QuickQuoteDataState = {
  loaded: false,
  loading: false,
  premium: null,
  paymentSchedule: null,
  error: false,
  status: null,
  ansError: false,
  ansStatus: null,
  exceptionAnsError: false,
  exceptionAnsStatus: null
};

const quickQuoteDataReducer = createReducer(
  initialState,
  on(quickQuoteDataActions.getQuickQuote, (state, action) => ({
    ...state,
    loading: true,
    loaded: false
  })),
  on(
    quickQuoteDataActions.getQuickQuoteSuccess,
    quickQuoteDataActions.getQuoteSuccess,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      premium: action.response.premium
    })
  ),
  on(quickQuoteDataActions.getQuickQuoteFailed, (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: true,
    status: action.error
  })),
  on(
    quickQuoteDataActions.ansNotificationFailed,
    quickQuoteDataActions.ansNotificationOnBindFailed,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      ansError: true,
      ansStatus: action.status
    })
  ),
  on(quickQuoteDataActions.ansNotificationOnErrorFailed, (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    exceptionAnsError: true,
    exceptionAnsStatus: action.status
  })),
  on(
    quickQuoteDataActions.ansNotification,
    quickQuoteDataActions.ansNotificationOnError,
    quickQuoteDataActions.ansNotificationOnBind,
    (state, action) => ({
      ...state,
      loading: true,
      loaded: false
    })
  ),
  on(
    quickQuoteDataActions.ansNotificationSuccess,
    quickQuoteDataActions.ansNotificationOnErrorSuccess,
    quickQuoteDataActions.ansNotificationOnBindSuccess,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      ansError: false,
      ansStatus: null
    })
  ),
  on(quickQuoteDataActions.loadFuturePaymentsSuccess, (state, action) => ({
    ...state,
    paymentSchedule: action.paymentSchedule
  })),
  on(quickQuoteDataActions.loadFuturePaymentsFailed, (state, action) => ({
    ...state,
    paymentSchedule: null,
    error: null
  })),
  on(quickQuoteDataActions.resetExceptionANSError, (state, action) => ({
    ...state,
    exceptionAnsError: false,
    exceptionAnsStatus: null
  })),
  on(quickQuoteDataActions.resetANSError, (state, action) => ({
    ...state,
    ansError: false,
    ansStatus: null
  })),
  on(quickQuoteDataActions.resetQuickQuoteError, (state, action) => ({
    ...state,
    error: false,
    status: null
  })),
  on(quickQuoteDataActions.resetQuickQuote, (state, action) => initialState)
);

export function reducer(state: QuickQuoteDataState | undefined, action: Action) {
  return quickQuoteDataReducer(state, action);
}
